import React from "react"
//import { Link } from "gatsby"
import { Link } from "gatsby-theme-material-ui"

import PropTypes from "prop-types"
import {
  Grid,
  Button,
  AppBar,
  Toolbar,
  Slide,
  Container,
} from "@material-ui/core"
import useScrollTrigger from "@material-ui/core/useScrollTrigger"
import { makeStyles } from "@material-ui/core/styles"
import BackgroundMusic from "./BackgroundMusic"
import LogoHeissenbergerLabs from "./Logo/LogoHeissenbergerLabs.js"
import backgrondMusicFile from "../assets/sound/mixkit-keep-dancin-811.mp3"
import { useStaticQuery, graphql } from "gatsby"

function HideOnScroll(props) {
  const { children, window } = props
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined })

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
}

const HeaderStyle = theme => ({
  root: {
    backgroundColor: "rgb(0,0,0,0.8)!important",
  },
  appbar: {
    backgroundColor: "black",
  },
  toolbar: {
    paddingLeft: 0,
  },
  logo: {
    padding: "1rem 1rem 1rem 0",
    [theme.breakpoints.up("lg")]: {
      height: "8rem",
    },
    height: "6rem",
    "@media print": {
      "& .logo-text-color": {
        fill: "black",
      },
      "& .logo-outline-color": {
        stroke: "black",
      },
    },
  },
  button_root: {
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      textDecoration: "none!important",
    },
  },
  button_label: {
    color: "black",
  },
})

const useStyles = makeStyles(HeaderStyle)

const Header = () => {
  const classes = useStyles()
  const data = useStaticQuery(graphql`
    query SiteTitleQueryEN {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <HideOnScroll>
      <AppBar
        classes={{ colorPrimary: classes.appbar }}
        className={classes.root}
      >
        <Container maxWidth="lg">
          <Toolbar className={classes.toolbar}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <Link to="/en/" title="Home">
                  <LogoHeissenbergerLabs
                    className={classes.logo}
                    variant="white"
                    title={data.site.siteMetadata.title}
                  />
                </Link>
              </Grid>
              <Grid item>
                <Button
                  to="/en/#kontakt"
                  color="inherit"
                  classes={{
                    root: classes.button_root,
                    label: classes.button_label,
                  }}
                  variant="contained"
                  component={Link}
                >
                  Contact
                </Button>
                <BackgroundMusic
                  sound={backgrondMusicFile}
                  title={"Background Music"}
                />
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </HideOnScroll>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
